import { Children } from 'react';
import 'react-alice-carousel/lib/scss/alice-carousel.scss';
import { BaseCarousel } from '../BaseCarousel/BaseCarousel';
import { CarouselProps } from './Carousel.types';

/** Rotates through the items. */
export const Carousel = ({ items, name }: CarouselProps) => {
    const validItems = Children.toArray(items);

    return (
        <BaseCarousel
            name={name}
            items={validItems}
            autoPlay={validItems.length >= 2}
            disableButtonsControls
            disableDotsControls
            disableSlideInfo
            infinite
            autoPlayInterval={10000}
        />
    );
};
